import './scss/_cffgf.scss';

import './js/gravity-forms-js/index.js';
